import * as React from 'react';
import { createElement } from 'react';
import { default as List } from './position-list';
import { default as Position } from './position-left';
const Navigation = function BottomNavigation({ itemArray, defaultLocation, __designMode, ...otherProps }) {
    const [current, setCurrent] = React.useState(defaultLocation);
    const [isOpen, setIsOpen] = React.useState(false);
    const openList = () => {
        if (__designMode == 'design') {
            return;
        }
        setIsOpen(!isOpen);
    };
    return (createElement("div", null,
        createElement(Position, { currentLocation: current, ...otherProps, clickHandle: () => openList() }),
        createElement(List, { open: isOpen, currentLocation: current, itemArray: itemArray, setIsOpen: openList, setCurrent: (value) => setCurrent(value) })));
};
export default Navigation;
